import { render, staticRenderFns } from "./Prodelivery.vue?vue&type=template&id=3bfec17b"
import script from "./Prodelivery.vue?vue&type=script&lang=js"
export * from "./Prodelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports